import React from 'react';
import { fileUrl, webpSrcSet, jpegSrcSet } from '../utils/imageUrl';

/**
 * Lazy, responsive image with WebP first + JPEG fallback.
 * Use this everywhere we render a backend-stored image (listing cards, thumbnails, detail page).
 *
 * Props:
 *  - path: storage path (e.g. listing.images[0])
 *  - sizes: HTML "sizes" attribute (defaults to a sensible mobile-first guess)
 *  - className / alt / dataTestid / loading / fetchPriority forwarded
 */
const ResponsiveImage = ({
  path,
  alt = '',
  sizes = '(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 320px',
  widths = [256, 512, 1024],
  className = '',
  loading = 'lazy',
  fetchPriority,
  decoding = 'async',
  dataTestid,
  onClick,
}) => {
  if (!path) return null;
  return (
    <picture>
      <source type="image/webp" srcSet={webpSrcSet(path, widths)} sizes={sizes} />
      <source type="image/jpeg" srcSet={jpegSrcSet(path, widths)} sizes={sizes} />
      <img
        src={fileUrl(path, { w: widths[1] || 512, fmt: 'jpeg' })}
        alt={alt}
        loading={loading}
        decoding={decoding}
        fetchpriority={fetchPriority}
        className={className}
        data-testid={dataTestid}
        onClick={onClick}
      />
    </picture>
  );
};

export default ResponsiveImage;
